import * as React from "react";
const AddMedia = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 31 31", fill: "currentColor", width: size || "31", height: size || "31", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 15H0v1h15v15h1V16h15v-1H16V0h-1z" }));
AddMedia.displayName = "AddMedia";
var AddMedia_default = AddMedia;
export {
  AddMedia_default as default
};
